<script setup lang="ts">
import { EventTypeEnum } from "@/models";
import { useDataLayerStore } from "@/stores";
import { onMounted, computed } from "vue";
import PageHeading from "@/components/general/PageHeading/PageHeading.vue";
import JourneyLayout from "@/components/layout/JourneyLayout/JourneyLayout.vue";

const props = withDefaults(
    defineProps<{
        errorCode?: number;
    }>(),
    {
        errorCode: 500,
    }
);

const errorMessage = computed(() => {
    if (props.errorCode === 500) {
        return [
            "We can’t offer you Over 50s Insurance right now.",
            "This service is unavailable whilst we fix a problem.",
            "We will get this restored shortly.",
        ];
    } else {
        return [
            "We've looked everywhere but we can't find the page you're looking for.",
        ];
    }
});

onMounted(() => {
    const dataLayerStore = useDataLayerStore();
    dataLayerStore.pageNumber = 9;
    if (!dataLayerStore.pageError) {
        dataLayerStore.pageError = {
            errorType: "",
            errorCode: 500,
            errorMessage:
                "You can still get a quotation over the phone by calling 0800 316 8435",
        };
        dataLayerStore.triggerEvent(EventTypeEnum.ErrorEvent);
    }
});
</script>

<template>
    <div id="error-page" class="container-fluid content-padding">
        <JourneyLayout>
            <template #main>
                <PageHeading> {{ props.errorCode }} - Oops! </PageHeading>
                <div v-for="message in errorMessage" :key="message">
                    <p>
                        {{ message }}
                    </p>
                </div>
            </template>
        </JourneyLayout>
    </div>
</template>

<style scoped>
h2 {
    font-size: 32px;
}
</style>
